import { Route, RouteMeta } from './Route'
import { AccountFragment } from 'src/graphql'

export type RouteType = {
  path: string
  subroute?: RouteType
}

export const findRoute = <T extends RouteMeta<any, any, any>>(
  route: RouteType,
  subroute: T,
): Route<T> | undefined =>
  route.path === subroute.path
    ? ((route as unknown) as Route<T>)
    : route.subroute && findRoute(route.subroute, subroute)

export const doesNotHaveAccessToPrivateRoutes = (
  account?: AccountFragment | null,
  error?: Error,
): boolean =>
  !!(
    (account &&
      account.isNewUser &&
      account.plan.isLimited &&
      !account.isStaff) ||
    error
  )
